const messages = {
  title: "Lo que necesitas para impulsar",
  text: "Su proyecto digital",
  paragraph: "Diseño, UI/UX, Paginas web, Aplicaciones mobiles y más.",
  btnSwip: "¡Desliza!",
  btnContent: "Para impulsarte "
};

export default messages;
